/******
 *
 * Account API
 ******/

import Request from "@/utils/Request";

export default {
  /*
    예금주 확인 (JSON)
  */
  account(bankCd, accountNo, accountNm) {
    return Request({
      url: "/SimpleEntry/confirm",
      // 필요 시 풀 URL
      // url: "https://ext.daeguro.co.kr:45010/api/SimpleEntry/confirm",
      method: "post",
      data: {
        bankCode: bankCd,
        accountNo: accountNo,
        accOwner: accountNm,
      },
      headers: {
        "Content-Type": "application/json",
      },
    });
  },
};
